const config = {
  zoom: {
    scale: 2,
    threshold: 0.105
  },
  image: {
    quality: 70,
    sizes: {
      default: {
        desktop: {
          width: 750,
          height: 440,
          thumbnail: {
            width: 134,
            height: 134
          }
        },
        tablet: {
          width: 750,
          height: 440,
          thumbnail: {
            width: 110,
            height: 110
          }
        },
        mobile: {
          width: 500,
          height: 500,
          thumbnail: {
            width: 90,
            height: 90
          }
        }
      },
      portrait: {
        desktop: {
          width: 598,
          height: 810,
          thumbnail: {
            width: 80,
            height: 108
          }
        },
        tablet: {
          width: 598,
          height: 810,
          thumbnail: {
            width: 80,
            height: 80
          }
        },
        mobile: {
          width: 320,
          height: 432,
          thumbnail: {
            width: 80,
            height: 80
          }
        }
      }
    },
    madeToOrderSizes: {
      default: {
        desktop: {
          width: 750,
          height: 750,
          thumbnail: {
            width: 134,
            height: 134
          }
        },
        tablet: {
          width: 750,
          height: 750,
          thumbnail: {
            width: 110,
            height: 110
          }
        },
        mobile: {
          width: 500,
          height: 500,
          thumbnail: {
            width: 90,
            height: 90
          }
        }
      },
      portrait: {
        desktop: {
          width: 598,
          height: 598,
          thumbnail: {
            width: 80,
            height: 80
          }
        },
        tablet: {
          width: 598,
          height: 598,
          thumbnail: {
            width: 80,
            height: 80
          }
        },
        mobile: {
          width: 320,
          height: 320,
          thumbnail: {
            width: 80,
            height: 80
          }
        }
      }
    }
  }
}
export default config
